export enum IconType {
  Info = 1,
  Warning = 2
}
